import _extends from "@babel/runtime/helpers/esm/extends";
import * as React from "react";
var SvgBars = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("style", null, "\n        .spinner_hzlK {\n            fill: currentColor;\n            animation: spinner_vc4H .8s linear infinite;\n            animation-delay: -.8s\n        }\n\n        .spinner_koGT {\n            animation-delay: -.65s\n        }\n\n        .spinner_YF1u {\n            animation-delay: -.5s\n        }\n\n        @keyframes spinner_vc4H {\n            0% {\n                y: 1px;\n                height: 22px\n            }\n\n            93.75% {\n                y: 5px;\n                height: 14px;\n                opacity: .2\n            }\n        }\n    "), /*#__PURE__*/React.createElement("rect", {
  className: "spinner_hzlK",
  x: 1,
  y: 1,
  width: 6,
  height: 22
}), /*#__PURE__*/React.createElement("rect", {
  className: "spinner_hzlK spinner_koGT",
  x: 9,
  y: 1,
  width: 6,
  height: 22
}), /*#__PURE__*/React.createElement("rect", {
  className: "spinner_hzlK spinner_YF1u",
  x: 17,
  y: 1,
  width: 6,
  height: 22
}));
var bars_default = SvgBars;
export { bars_default as default };
//# sourceMappingURL=bars.svg.js.map